import styles from './index.module.scss';
import { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { PropType, defineComponent, h } from 'vue';
import { Page } from '../../components/page';
import { Flex } from '@phi/components/layout';
import { CircleWithCheckbox } from '../../components/circle-with-checkbox';
import { Text } from '@components/text';
import { rem } from '@phi/util/css';

export const EmailSentPage = defineComponent({
    name: 'EmailSentPage',

    props: {
        app: { required: true, type: Object as PropType<IFrontendServiceContainer> },
    },

    setup({ app }) {
        const util = app.util;
        return () => h(Page, { light: app.util.dark_mode_enabled() }, () => h(Flex, {
            direction: 'row',
            align: 'center',
            gap: 'wider',
        }, () => [
            CircleWithCheckbox(util.dark_mode_enabled(), rem(3)),
            h('div', [
                h(Text, { size: 'huge' }, () => 'Email Sent'),
                h('div', { class: styles.body }, 'Check your email and open the link we sent to continue.'),
            ]),
        ]));
    },
});
